import { combineReducers } from 'redux';

import user from './user/reducer';
import temporizador from './temporizador/reducer';
import simulacaoBeneficio from './simulacaoBeneficio/reducer';
import recuperacaoSenha from './recuperacaoSenha/reducer';
import customizaSistema from './personalizacaoCor/reducer';
import customizaHome from './personalizacaoHome/reducer';
import requerimento from './requerimento/reducer';
import tourBoasVindas from './boasVindas/reducer';
import loading from './loading/reducer';
import extratoContribuicao from './extratoContribuicao/reducer';
import emprestimo from './emprestimo/reducer';
import telasDisponiveis from './telasDisponiveis/reducer';
import menuAtendimentoVirtual from './atendimentoVirtual/reducer';

export default combineReducers({
  user,
  temporizador,
  simulacaoBeneficio,
  recuperacaoSenha,
  customizaSistema,
  customizaHome,
  requerimento,
  tourBoasVindas,
  loading,
  extratoContribuicao,
  emprestimo,
  telasDisponiveis,
  menuAtendimentoVirtual,
});
